module.exports = __webpack_public_path__ + "static/img/logo_with_text.b4873f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_with_text.png
// module id = 428
// module chunks = 1